import {ValidationErrorDescription} from './ValidationErrorDescription';

export class SimulationResponse
{
    public readonly topologyId:string;
    public readonly success:boolean;
    public readonly errors:ValidationErrorDescription[];

    constructor(json:any)
    {
        this.topologyId = json['topologyId'];
        this.success = json['success'];
        this.errors = [];
        for( let i = 0, length = (json['errors'] || []).length; i < length; i++ )
        {
            this.errors.push(new ValidationErrorDescription(json['errors'][i]));
        }
    }
}
